export default __webpack_public_path__ + "static/media/egg1.fa6f5a42.jpg";